// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event-belonging-preview[data-v-70e88c16]{width:40px;height:40px;border-radius:50%}\n", ""]);
// Exports
module.exports = exports;
